export {
  getStaticPaths,
  getStaticProps,
  default
} from 'components/pages/LotBasePage'
